import { ThemeType } from '../api/static/ThemeType';
/**
 * @typedef {Object<PrintTypeId,Object<SizeId, Object<ProductId, ProductVariantId[]>>>} ProductVariantIndex
 */

/**
 *
 * @param {ProductVariant[]} productVariants
 * @param {Object<string, Product>} productMap
 * @return {ProductVariantIndex}
 */
export function productVariantIndex(productVariants, productMap) {
  return productVariants.reduce((acc, pv) => {
    const product = productMap[pv.productId];

    if (!product) {
      throw new Error('Product not found.');
    }

    const customizableKey = product.isCustomizable
      ? ThemeType.CUSTOM
      : ThemeType.GENERIC;

    if (!acc[customizableKey]) {
      acc[customizableKey] = {};
    }

    if (!acc[customizableKey][pv.sizeId]) {
      acc[customizableKey][pv.sizeId] = { _items: [] };
    }

    if (!acc[customizableKey][pv.sizeId][pv.productId]) {
      acc[customizableKey][pv.sizeId][pv.productId] = [];
    }

    acc[customizableKey][pv.sizeId]._items.push(pv.id);
    acc[customizableKey][pv.sizeId][pv.productId].push(pv.id);

    return acc;
  }, {});
}

/**
 *
 * @param {ProductVariantIndex} index
 * @param {ThemeType} themeType
 * @param {SizeId} sizeId
 * @param {ProductId} productId
 */
export function readFromIndex(index, themeType, sizeId, productId = null) {
  if (!themeType) {
    throw new Error('pas de theme type!');
  }

  if (!Object.values(ThemeType).includes(themeType)) {
    console.log(Object.values(ThemeType), themeType);
    throw new Error(`theme type invalide: ${themeType}`);
  }

  const res = index[themeType] && index[themeType][sizeId];

  if (res) {
    if (productId) {
      if (res[productId]) {
        return res[productId];
      }
    } else {
      return res._items;
    }
  }

  return [];
}

let intlCollatorCache;

/**
 *
 * @param a
 * @param b
 * @return {number}
 */
export function sortAttributeOption(a, b) {
  if (!intlCollatorCache) {
    intlCollatorCache = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  }

  return intlCollatorCache.compare(a.name, b.name);
}
